import {durationUnits} from 'utilities/helper/durationUnitsOption';
import {rateUnits} from 'utilities/helper/rateUnitsOptions';

export const initialValues: IOnSaleInitialValues = {
  price: '',
  min_price: '',
  duration: '',
  duration_unit: durationUnits[0].value?.toString(),
  decline_rate: '',
  rate_unit: rateUnits[0].value?.toString(),
};
